export function initializeReactGA(path) {
  if (process.env.REACT_APP_ID_ANALYTICS !== undefined && process.env.REACT_APP_ID_ANALYTICS !== '' && !!path) {
    const reactGa = require('react-ga');
    reactGa.initialize(process.env.REACT_APP_ID_ANALYTICS);
    reactGa.pageview(`/${path}`);
  }
}

export function eventReactGA(cat, act) {
  const reactGa = require('react-ga');
  reactGa.event({
    category: cat,
    action: act,
  });
}
